import React from "react";
import { ICON_SIZES, ICON_TYPES } from "@/constants/icons";
import { cn } from "@/lib/helpers/cn";

export function MenuItem({
  automationDataAttr,
  className = "",
  href,
  icon: IconComponent,
  onClick,
  rel,
  target,
  text,
}) {
  const iconElement = IconComponent && (
    <IconComponent
      iconType={ICON_TYPES.OUTLINE}
      iconSize={ICON_SIZES.SMALL}
      className="tw:mr-1 tw:fill-fill-teal-primary"
    />
  );

  const menuItemClasses = cn("tw:flex", className);
  const baseMenuClasses = cn(
    "tw:flex tw:items-center tw:gap-1 tw:leading-none",
    "tw:cursor-pointer tw:text-text-teal-primary! tw:no-underline tw:hover:text-text-secondary! tw:active:text-text-secondary!",
  );

  if (href) {
    return (
      <a className={cn(baseMenuClasses, menuItemClasses)} href={href} target={target} rel={rel}>
        {iconElement}

        <span>{text}</span>
      </a>
    );
  }

  return (
    <div
      className={cn(menuItemClasses, baseMenuClasses, className)}
      onClick={onClick}
      role="menuitem"
      {...automationDataAttr}
    >
      {iconElement}

      <span>{text}</span>
    </div>
  );
}
